import { MailFolderScenarioType } from 'owa-mail-list-store';

export function isFavoritesSearchFolderScenario(scenarioType: MailFolderScenarioType): boolean {
    return (
        scenarioType === 'persona' ||
        scenarioType === 'privatedistributionlist' ||
        scenarioType === 'category'
    );
}
